export class AreaOracleServiceCloudModel {
  public typeUser: any[] = [];
  public skillType100: any[] = [];
  public skillType50: any[] = [];
  public membershipGroup: string;
  public workingArea: string;
  public notes: string;
}
